export const services = [
  {
    num: '01',
    slug: 'putz-stuck',
    title: 'Putz & Stuck',
    desc: 'Professionelle Lösungen für hochwertige Wand- und Fassadenoberflächen.',
    longText: 'Ob feiner Innenputz oder dekorativer Stuck — wir bringen jede Wand in die passende Form. Saubere Kanten, gleichmäßige Oberflächen und ein fachgerechter Aufbau sorgen dafür, dass das Ergebnis dauerhaft schön bleibt.',
    img: '/assets/klob-svc-01.jpg',
    features: ['Innenputz & Außenputz', 'Stuck- und Zierelemente', 'Untergrundvorbereitung', 'Kanten- und Anschlussarbeiten'],
  },
  {
    num: '02',
    slug: 'innen-aussenputz',
    title: 'Innen- & Außenputz',
    desc: 'Sauber und fachgerecht — gepflegte Oberflächen für Fassade und Innenräume.',
    longText: 'Eine gepflegte Fassade und glatte Innenwände sind die Basis für ein gutes Ergebnis. Wir arbeiten mit bewährten Materialien und achten auf einen sauberen Übergang zwischen Untergrund und Oberfläche.',
    img: '/assets/klob-svc-02.jpg',
    features: ['Fassadensanierung', 'Innenwandputz', 'Oberflächenstruktur nach Wunsch', 'Witterungsbeständige Ausführung'],
  },
  {
    num: '03',
    slug: 'malerarbeiten',
    title: 'Malerarbeiten',
    desc: 'Saubere Anstriche und gepflegte Oberflächen für Räume und Fassaden.',
    longText: 'Von einzelnen Räumen bis zur kompletten Wohnung: Wir decken sorgfältig ab, arbeiten sauber und streichen in der von Ihnen gewünschten Farbtonqualität — gleichmäßig und ohne sichtbare Ansätze.',
    img: '/assets/klob-svc-03.jpg',
    features: ['Innenanstrich', 'Fassadenanstrich', 'Tapezierarbeiten', 'Spachtel- und Schleifarbeiten'],
  },
  {
    num: '04',
    slug: 'estrich',
    title: 'Estrich',
    desc: 'Professionelle Grundlage für langlebige Bodenaufbauten.',
    longText: 'Ein fachgerechter Estrich ist die Voraussetzung für einen stabilen Bodenaufbau. Wir achten auf die richtige Zusammensetzung, gleichmäßige Höhen und eine saubere Übergabe an die Folgegewerke.',
    img: '/assets/klob-svc-04.jpg',
    features: ['Zement- und Fließestrich', 'Dämmung & Aufbau', 'Trittschall- und Wärmedämmung', 'Übergabe an Bodenleger'],
  },
  {
    num: '05',
    slug: 'fliesenverlegung',
    title: 'Fliesenverlegung',
    desc: 'Saubere und präzise Verlegung für hochwertige Ergebnisse.',
    longText: 'Fliesen verlangen Genauigkeit. Wir arbeiten mit sauberen Fugenbildern, exakten Schnitten und einem Untergrund, der zum Material passt — für Bad, Küche, Terrasse oder Objektbau.',
    img: '/assets/klob-svc-05.jpg',
    features: ['Wand- & Bodenfliesen', 'Groß- und Feinformat', 'Nassbereich & Terrasse', 'Fugenbild nach Absprache'],
  },
  {
    num: '06',
    slug: 'innenausbau',
    title: 'Innenausbau',
    desc: 'Komplette, sauber ausgeführte Lösungen für Ihre Räume.',
    longText: 'Wenn mehrere Gewerke zusammenspielen, kommt es auf die Abstimmung an. Wir koordinieren die einzelnen Schritte und liefern einen Innenausbau, der vom Rohbau bis zur fertigen Oberfläche passt.',
    img: '/assets/klob-svc-06.jpg',
    features: ['Trockenbau & Wände', 'Ausbau kompletter Räume', 'Abstimmung aller Gewerke', 'Renovierung & Modernisierung'],
  },
];